import { ReactElement } from 'react';
import { Card, CardContent } from '@mui/material';
import { DEFAULT_EC2_ROUTES } from '@localstack/constants';
import { useAwsGetter, useRoutes } from '@localstack/services';
import { PageTitle, SecurityGroupDetails } from '@localstack/ui';
import { useParams } from 'react-router-dom';

import { EC2Props } from './types';

export const SecurityGroup = ({ Layout, clientOverrides, routes = DEFAULT_EC2_ROUTES }: EC2Props): ReactElement => {
  const { goto } = useRoutes();
  const { groupId } = useParams<'groupId'>();

  const { data: securityGroups } = useAwsGetter('EC2', 'describeSecurityGroups', [{ GroupIds: [groupId as string] }], {
    clientOverrides,
  });
  const securityGroup = securityGroups?.SecurityGroups?.[0];

  return (
    <Layout
      documentTitle="EC2: Security Group Details"
      title={
        <PageTitle
          title="Security Group Details"
          breadcrumbs={[
            ['EC2', () => goto(routes.RESOURCES_EC2)],
            ['Security Groups', () => goto(routes.RESOURCES_EC2_SECURITY_GROUPS)],
            [groupId, null],
          ]}
        />
      }
    >
      <Card>
        <CardContent>
          <SecurityGroupDetails securityGroup={securityGroup} />
        </CardContent>
      </Card>
    </Layout>
  );
};
